import type { AqsiSale } from './types'

/** Корзину можно менять — как у службы (`CanEditCart`): ни деньги, ни чек не могли случиться. */
export function canEditCart(sale: AqsiSale): boolean {
  return (
    !sale.isFinished &&
    ['Pending', 'Failed', 'NotRequired'].includes(sale.payment) &&
    ['Pending', 'Failed'].includes(sale.fiscal)
  )
}
